module.exports = __webpack_public_path__ + "img/person_running.b9f7d2c7.gif";